import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Header from '../Landing/components/Header'
import { FloatingLabel } from 'react-input-textboxs'
import Button from '@material-ui/core/Button';
import MuiAudioPlayer from "./../../Components/AudioPlayer";
import { fetchSpecificFileName,setPageName } from './../../service/action/audio-track-action'
class ListernAudio extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            name: "",

        }
    }

    componentWillMount() {
        this.props.setPageName("Verify Audio File")
    }
    handleChange(value, key) {
        this.setState({ [key]: value })
    }
    render() {

        const { adminDashBoard: { currentFile },page } = this.props
        console.log(this.props.adminDashBoard)
        return (
            <div className="right-section">
                <Header page={page} />

                <div className="aosm">
                    <FloatingLabel
                        label="Enter the file name"
                        type="text"
                        value={this.state.name}
                        variant="outline"
                        onChange={(value) => this.handleChange(value, 'name')} />
                    <div>
                        <Button 
                        onClick={()=> this.props.fetchSpecificFileName(this.state.name)}
                        variant="contained" 
                        color="primary">
                            Search
                        </Button>
                    </div>
                </div>
                {currentFile && currentFile.filePath !== null ?
                <div className="playAudio">
                    <MuiAudioPlayer
                        src={currentFile.filePath}
                        autoPlay={true}
                    /> 
                </div>: null }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { userLogin, adminDashBoard, loading, page } = state
    return {
        userLogin,
        adminDashBoard,
        loading,
        page
    }
}

const mapDispatchToProps = dispatch => ({
    fetchSpecificFileName: (name) =>
        dispatch(fetchSpecificFileName(name)),
        setPageName:(a) => dispatch(setPageName(a))

})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListernAudio))
